import { catchError, map, Observable, of, tap } from 'rxjs';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { RoomDTO } from '../../../../dto/location/room.dto';
import { Room } from '../../../../models/location/Room.model';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { environment } from '../../../../environment/environment';

export function rooms(componentDataSourceService: ComponentDataSourceService) {
    return {
      name: 'Rooms',
      description: 'List of all rooms in locations',
      execute: (params?: LoadDataParams) => {
        
        return componentDataSourceService.http.get<any>(
          `${environment.apiUrl}/locations/rooms`,
          params?.queryParams ? { params: params.queryParams } : {}
        ).pipe(
          catchError(error => {
            console.error('Error fetching rooms:', error);
            return of({ items: [], totalCount: 0 });
          }),
          map(result => {
            if (result && result.items) {
              try {
                const rooms = result.items.map((room: any) => {
                  const roomDTO: RoomDTO = {
                    guid: room.guid,
                    room_name: room.room_name,
                    location_guid: room.location_guid,
                    capacity: room.capacity,
                    description: room.description,
                    locations_name: room.locations_name
                  };
                  
                  return Room.fromDTO(roomDTO);
                });

                return {
                  items: rooms,
                  totalCount: result.totalCount,
                  pageSize: result.pageSize,
                  pageIndex: result.pageIndex
                };
              } catch (error) {
                console.error('Error converting DTO to Room:', error);
                return { items: [], totalCount: 0 };
              }
            } else {
              throw new Error('No rooms found');
            }
          })
        );
      },
      settings: {
        columns: [
          { key: 'room_name', header: 'Navn', type: 'text' },
          { key: 'capacity', header: 'Kapacitet', type: 'number' },
          { key: 'description', header: 'Beskrivelse', type: 'text' }
        ],
        pageable: true,
        sortable: true,
        rowHover: true,
        searchable: true,
        defaultSortColumn: 'room_name',
        defaultSortDirection: 'asc'
      }
    }
} 